<template>
    <Form
        style="line-height: 32px"
        :label-width="120"
        ref="form"
        :model="formdata"
        inline
    >
        <FormItem
            style="width: 90%"
            :label="
                $t('erp.b2c.search_outwarehouse', { defaultValue: '发货仓库' })
            "
            prop="orgWarehouseId"
        >
            <Select
                v-model="formdata.orgWarehouseId"
                :placeholder="
                    $t('erp.b2c.orgWarehouse_null', {
                        defaultValue: '不选时不做处理',
                    })
                "
                filterable
                clearable
                @on-clear="valueClear(1)"
            >
                <!-- <Option value="0">System Auto</Option> -->
                <Option
                    v-for="item in warehouseList"
                    :value="item.attach.id"
                    :key="item.attach.id"
                    >{{ item.label }}</Option
                >
            </Select>
        </FormItem>
        <FormItem
            style="width: 90%"
            :label="$t('erp.b2c.shipping_method', { defaultValue: '发货方式' })"
            prop="shippingMethodCode"
        >
            <Select
                v-model="formdata.shippingMethodCode"
                :placeholder="
                    $t('erp.b2c.orgWarehouse_null', {
                        defaultValue: '不选时不做处理',
                    })
                "
                filterable
                clearable
                ref="refshipping"
                @on-change="validIsNull"
                @on-clear="valueClear(2)"
            >
                <!-- <Option value="AUTO">System Auto</Option> -->
                <Option
                    v-for="item in shippingList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                >
            </Select>
        </FormItem>
        <FormItem
            style="width: 90%"
            :label="$t('global.common.notes', { defaultValue: '备注' })"
        >
            <Input v-model="formdata.remark" :rows="3" type="textarea" />
        </FormItem>
        <footer class="text-right">
            <Button type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button class="margin-left-10" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </Form>
</template>
<script>
import {
    HttpGetAllCustomerIdCode,
    HttpsSaveLogistics,
} from "@/service/boss/b2corder";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeids"],
    watch: {
        getNewWarehouseCodeList: {
            deep: true,
            immediate: true,
            handler(val) {
                this.warehouseList = this.concatTarget.concat(val);
            },
        },
    },
    data() {
        return {
            warehouseList: [],
            formdata: {
                orgWarehouseId: "",
                shippingMethodCode: "",
                remark: "",
            },
            // warehouseId:'',
            shippingList: [],
            loading: false,
            required: [
                {
                    required: true,
                    message: this.$t("global.common.fill_requiredd", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            concatTarget: [
                {
                    value: "",
                    label: "System Auto",
                    attach: {
                        item: {
                            id: 0,
                        },
                    },
                },
            ],
        };
    },
    created() {
        this.getShipping();
    },
    computed: {
        ...mapGetters("diction", ["getNewWarehouseCodeList"]),
    },
    methods: {
        valueClear(flag) {
            switch (flag) {
                case 1:
                    this.formdata.orgWarehouseId = "";
                    break;
                case 2:
                    this.formdata.shippingMethodCode = "";
                    break;
            }
        },
        validIsNull() {
            if (
                !this.formdata.shippingMethodCode &&
                (this.formdata.orgWarehouseId === "" ||
                    this.formdata.orgWarehouseId === undefined)
            ) {
                this.$Message.error(
                    this.$t("erp.b2c.shipping_warehouse_method", {
                        defaultValue: "发货仓库和发货方式不可以同时为空",
                    })
                );
                return false;
            } else {
                return true;
            }
        },
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        cancel() {
            this.$emit("on-close");
        },
        getShipping() {
            // if (this.formdata.orgWarehouseId === undefined) {
            //     return this.formdata.orgWarehouseId === ''
            // }
            // this.loading = true;
            // this.$refs.refshipping.clearSingleSelect()
            // this.warehouseList.map((item)=>{
            //     // console.log(item)
            //     if(item.attach.id == this.formdata.orgWarehouseId){
            //         this.formdata.orgWarehouseId = item.attach.id

            //         this.formdata.orgWarehouseCode = item.value
            //     }
            // })
            // if (this.formdata.orgWarehouseId === 0 || this.formdata.orgWarehouseId === '') {
            //     this.loading = false
            //     return this.shippingList = [
            //         {label:'System Auto', value: 'System Auto'},
            //         // {carrierServiceCode:'WLC'},
            //         {label:'YRC', value: 'YRC'},
            //         {label:'Australia Post', value: 'Australia Post'},
            //         {label:'Other', value: 'Other'}
            //     ]
            // }
            HttpGetAllCustomerIdCode()
                .then(
                    (res) => {
                        // let aaa = [
                        //     {label:'WLC', value: 'WLC'},
                        //     {label:'YRC', value: 'YRC'},
                        //     {label:'Australia Post', value: 'Australia Post'},
                        //     {label:'Other', value: 'Other'}
                        // ]
                        // let concatArr = [
                        //     {label: 'System Auto', value: 'System Auto'}
                        // ]
                        let dataArr = res.data.map((item) => {
                            return {
                                label: `${item.code}(${item.carrierServiceName})`,
                                value: item.code,
                                attach: {
                                    ...item,
                                },
                            };
                        });
                        this.shippingList = dataArr;
                        // this.shippingList = concatArr.concat(this.shippingList.concat(aaa))
                        // this.shippingList = this.arrayUnique(this.shippingList,'value')
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        async submit() {
            let shippingMethodCode = this.formdata.shippingMethodCode;
            switch (shippingMethodCode) {
                case "System Auto":
                    shippingMethodCode = "AUTO";
                    break;
            }
            let valid = await this.$refs["form"].validate();
            if (!valid) return;
            if (!this.validIsNull()) {
                return;
            }
            let requestData = {
                orderIds: this.activeids,
                remark: this.formdata.remark,
            };
            if (shippingMethodCode !== "") {
                requestData.shippingMethod = shippingMethodCode;
            }
            if (
                this.formdata.orgWarehouseId !== "" &&
                this.formdata.orgWarehouseId !== undefined
            ) {
                requestData.orgWarehouseId = this.formdata.orgWarehouseId;
            }
            this.loading = true;
            HttpsSaveLogistics(requestData)
                .then(
                    (res) => {
                        this.cancel();
                        this.$emit("on-update");
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
